export const USER_KEY = 'USER';
export const TOKEN_KEY = 'TOKEN';
export const STATUS_CODE = {
  CREATED: 201,
  SUCCESS: 200,
  ACCEPTED: 202,
  INTERNAL_ERR: 500,
};

export enum SHARE_PERM_DROPDOWN {
  OWNER = 'OWNER',
  VIEWER = 'VIEWER',
  EDITOR = 'EDITOR',
  REMOVE = 'REMOVE',
}

export const SHARE_PERM_DROPDOWN_TEXT = {
  OWNER: "所有者",
  VIEWER: '閲覧者',
  EDITOR: '編集者',
  REMOVE: '削除',
}

